var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row-cols-lg-5"
  }, _vm._l(_vm.brands, function (brand) {
    return _c('v-col', {
      key: brand._id,
      staticClass: "list-item",
      attrs: {
        "cols": "4",
        "sm": "3"
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/gshop/brand/giftcards?_category=".concat(_vm._category || '', "&_brand=").concat(brand === null || brand === void 0 ? void 0 : brand._id)
      }
    }, [_c('v-img', {
      staticClass: "border w-100",
      attrs: {
        "src": "https://daehanbooksgiftcard.com/".concat(brand.thumb),
        "alt": "shinsegae",
        "contain": "",
        "aspect-ratio": 1 / 1
      }
    })], 1)], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }